import "@/utils/i18n";
import { nprogress } from "@mantine/nprogress";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import dayjs from "@workspace/domain/src/utils/dayjs";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./globals.css";
import { routeTree } from "./routeTree.gen";
import { queryClient } from "./utils/clients/orpc";
import { CONSTANTS } from "./utils/constants";
import { ADMIN_ENV } from "./utils/env";

if (CONSTANTS.LANGUAGE === "ar") dayjs.locale("ar");

posthog.init(ADMIN_ENV.VITE_PUBLIC_POSTHOG_KEY, {
  api_host: `${ADMIN_ENV.VITE_PUBLIC_API_URL}/aragon`,
  ui_host: ADMIN_ENV.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-05-24",
});
posthog.register({
  app: "admin",
});

const router = createRouter({
  routeTree,
  context: { queryClient, posthog },
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

setupRouterSsrQueryIntegration({
  router,
  queryClient,
});

// progress bar
router.subscribe("onBeforeLoad", ({ fromLocation, pathChanged }) => fromLocation && pathChanged && nprogress.start());
router.subscribe("onLoad", async () => nprogress.complete());

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <PostHogProvider client={posthog}>
        <RouterProvider router={router} />
      </PostHogProvider>
    </StrictMode>,
  );
}
